export enum MotivocontratacaotemporariaEnum {
  TP_INCLUSAO_SUBSTITUICAO_REGULAR = 1,
  TP_INCLUSAO_ACRESCIMO_EXTRAORDINARIO = 2
}
